<template>
    <a v-if="value" :href="url" target="_blank">{{fileName}}</a>
</template>

<script>
    import config from '../../config.js'

    export default {
        name: "AttachmentLink",
        props: ['value', 'name'],
        computed: {
            url() {
                return config.backendUrl + '/files?path=' + encodeURIComponent(this.value)

            },
            fileName() {
                if (this.name) {
                    return this.name
                } else {
                    return this.value.substring(this.value.lastIndexOf('/') + 1)
                }
            }
        }
    }
</script>
